import React from "react";

const SectionHeading = ({ eyebrow, title, subtitle, align = "left", light = false }) => {
  const textColor = light ? "text-[#FBF7F0]" : "text-[#3B2A1A]";
  const subColor = light ? "text-[#F2E7D5]/85" : "text-[#3B2A1A]/75";
  return (
    <div className={`max-w-3xl min-w-0 ${align === "center" ? "mx-auto text-center" : ""}`} data-testid="section-heading">
      {eyebrow && <div className={`overline mb-3 ${light ? "text-[#D4AF37]" : ""}`}>{eyebrow}</div>}
      <h2 className={`font-serif-display text-3xl sm:text-4xl lg:text-[44px] leading-[1.1] tracking-tight break-words ${textColor}`}>
        {title}
      </h2>
      <div className={`mt-4 gold-underline ${align === "center" ? "mx-auto" : ""}`} />
      {subtitle && <p className={`mt-5 text-base sm:text-lg leading-relaxed ${subColor}`}>{subtitle}</p>}
    </div>
  );
};

export default SectionHeading;
